import type { OptionKV } from "~styled/selector/Selector";

export enum ETipoCobertura {
  RC = "RC",
  TCBase = "TCBase",
  TCPremium = "TCPremium",
  TR = "TR",
}

const TODOS = "";
export const RC = ETipoCobertura.RC;
export const TCBASE = ETipoCobertura.TCBase;
export const TCPREMIUM = ETipoCobertura.TCPremium;
export const TR = ETipoCobertura.TR;

const tipoCoberturasOptions: Record<ETipoCobertura | typeof TODOS, string> = {
  [TODOS]: "Todos",
  [RC]: "Responsabilidad Civil",
  [TCBASE]: "Terceros Completo",
  [TCPREMIUM]: "Terceros Premium",
  [TR]: "Todo Riesgo",
};

const tipoCoberturasFilter: OptionKV<ETipoCobertura | typeof TODOS>[] = [
  { label: tipoCoberturasOptions[TODOS], value: TODOS },
  { label: tipoCoberturasOptions[RC], value: RC },
  { label: tipoCoberturasOptions[TCBASE], value: TCBASE },
  { label: tipoCoberturasOptions[TCPREMIUM], value: TCPREMIUM },
  { label: tipoCoberturasOptions[TR], value: TR },
];

export { tipoCoberturasOptions, tipoCoberturasFilter };
